import {
  IdCard, Landmark, House, Car, HeartPulse, GraduationCap, Briefcase, Users,
} from "lucide-react";
import PageHero from "../components/PageHero";
import CTASection from "../components/CTASection";
import { NEW_LIFE_SECTIONS, IMAGES } from "../data/content";

const ICONS = { IdCard, Landmark, House, Car, HeartPulse, GraduationCap, Briefcase, Users };

export default function NewLife() {
  return (
    <div data-testid="new-life-page">
      <PageHero
        eyebrow="New Life Services"
        title="Build Your New Life With a Plan"
        lead="Getting lawful status or submitting an immigration application does not automatically teach someone how to navigate everyday life in a new country. Our New Life Services help clients understand and coordinate the practical steps of becoming established in the United States."
        image={IMAGES.family}
        alt="A family building their new life together"
      />

      <section className="py-16 lg:py-24" data-testid="new-life-sections">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {NEW_LIFE_SECTIONS.map((section, i) => {
              const Icon = ICONS[section.icon];
              return (
                <div key={section.title} className="bg-surface border border-line rounded-xl p-6 shadow-sm hover:shadow-md hover:border-sage transition-all" data-testid={`new-life-card-${i}`}>
                  <div className="h-11 w-11 rounded-xl bg-sage-light flex items-center justify-center mb-4">
                    <Icon className="h-5 w-5 text-sage" />
                  </div>
                  <h3 className="text-lg font-sans font-semibold text-navy">{section.title}</h3>
                  <ul className="mt-3 space-y-2">
                    {section.items.map((item) => (
                      <li key={item} className="flex items-start gap-2 text-sm text-mutedink">
                        <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-sage flex-shrink-0" /> {item}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-20 bg-sand/60">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl font-serif font-semibold text-navy tracking-tight">A navigator beside you</h2>
          <p className="mt-4 text-lg text-mutedink leading-relaxed">
            Every New Life client works with a Newcomer Navigator — a real person who helps you prioritize, make appointments, fill out forms, and understand each system step by step.
          </p>
          <img src={IMAGES.community} alt="Community support and belonging" className="mt-10 rounded-2xl w-full h-72 object-cover shadow-md" />
        </div>
      </section>

      <CTASection title="Starting over is easier with a map." text="Tell us where you are in your journey. We will help you plan the next steps." primaryLabel="Explore With a Navigator" />
    </div>
  );
}
